module.exports = __webpack_public_path__ + "img/news-default.5cdeb31d.png";